import React from 'react';

function SaveIcon({ ...props }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="16"
            viewBox="0 0 14 16"
            fill="none"
            {...props}
        >
            <path
                d="M10.9542 0H3.04573C2.34877 0 1.75684 0.642428 1.75684 1.47303V14.8376C1.75889 15.8918 2.8856 16.3865 3.52615 15.6464L6.54063 12.2023C6.78221 11.9143 7.21772 11.9143 7.4593 12.2023L10.4738 15.6464C11.1146 16.3868 12.2412 15.8913 12.2431 14.8376V1.47303C12.2431 0.642428 11.6512 0 10.9542 0Z"
                fill="currentColor"
            />
        </svg>
    );
}

export default SaveIcon;
